import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {LovValueSummaryFieldComponent} from './lov-value-summary-field.component';
import {SummaryFieldModule} from '../../../../../../core/component/summary-field/summary-field.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        SummaryFieldModule,
    ],
    declarations: [
        LovValueSummaryFieldComponent,
    ],
    exports: [
        LovValueSummaryFieldComponent,
    ]
})
export class LovValueSummaryFieldModule {
}
